import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color", "disabled"];
var __jsx = React.createElement;
import React from "react";
const InputCheckIcon = _ref => {
  let {
      size = "20",
      color = "currentColor",
      disabled = false
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("rect", {
    x: "0.5",
    y: "0.5",
    width: "15",
    height: "15",
    rx: "7.5",
    stroke: color
  }), __jsx("circle", {
    cx: "8",
    cy: "8",
    r: "3",
    fill: color,
    display: disabled ? "none" : "block"
  }));
};
export default InputCheckIcon;